import React, { useEffect, useState } from "react";
import FleetUsageReportIcon from "assets/svgIcons/AdminDashboard/FleetUsageReportIcon";
import { COMMON_SERVICES } from "../../../../redux/reduxToolkitServices/_commonServices/commonServices";
import {
  Chart,
  ChartSeries,
  ChartTooltip,
  ChartSeriesItem,
  ChartCategoryAxis,
  ChartCategoryAxisItem,
  ChartTitle,
  ChartLegend,
} from "@progress/kendo-react-charts";
import "hammerjs";
import "@progress/kendo-theme-default/dist/all.css";
import { useDispatch, useSelector } from "react-redux";
import { useHookstate } from "@hookstate/core";
import { SITEID_GLOBAL_STATE } from "globalStore/globalStore";
import { useTranslation } from "react-i18next";
import { API_STATUSES } from "redux/_helpers/statuses";

const FleetUsageReports = () => {
  const { t } = useTranslation();
  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);
  const dispatch = useDispatch();
  const {
    getCarUsageState,
    getDashboardFeatureSetStatus,
    getCurrentCarsData,
    getMessagesFromCarsData,
    getCarsData,
    getFaultsData,
  } = useSelector((state) => state?.commonReducers) || [];

  const [RefreshChart, setRefreshChart] = useState(true);
  const [graphData, setGraphData] = useState([]);
  const [rangeHighAmpHours, setRangeHighAmpHours] = useState(null);
  const [rangeLowAmpHours, setRangeLowAmpHours] = useState(null);

  useEffect(() => {
    if (
      getDashboardFeatureSetStatus === API_STATUSES.SUCCESS &&
      siteId.get() !== null
    ) {
      dispatch(COMMON_SERVICES.getCarUsageServices(siteId.get(), true));
    }
  }, [getDashboardFeatureSetStatus, siteId.get()]);

  function getSigmaOnArray(arrayToSigma) {
    var arrayLength = arrayToSigma !== undefined && arrayToSigma.length;
    var interimArray = [];
    var initialArrayAverage = getAvgFromArray(arrayToSigma);
    for (var i = 0; i < arrayLength; i++) {
      interimArray.push(
        (arrayToSigma[i] - initialArrayAverage) *
          (arrayToSigma[i] - initialArrayAverage)
      );
    }
    var interimArrayAvergage = getAvgFromArray(interimArray);
    var arraySigma = Math.sqrt(interimArrayAvergage);
    return arraySigma;
  }

  function getAvgFromArray(arrayToAverage) {
    var arrayItemTotal = 0;
    var arrayLength = arrayToAverage !== undefined && arrayToAverage.length;
    for (var i = 0; i < arrayLength; i++) {
      arrayItemTotal = arrayItemTotal + arrayToAverage[i];
    }
    return arrayItemTotal / arrayLength;
  }

  useEffect(() => {
    if (getCarUsageState.length > 0 && getCarUsageState !== null) {
      let finalGraphData = [];
      let ampHoursArray = [];

      getCarUsageState?.forEach((el, i) => {
        finalGraphData.push({ ampHours: [el.AmpHours] });
        ampHoursArray.push(el.AmpHours);
      });

      var rangeAvgAmpHour;
      var rangeHighAmpHour;
      var rangeLowAmpHour;

      var sigmaOnAmpHours = Math.round(getSigmaOnArray(ampHoursArray));
      if (ampHoursArray.length > 0) {
        rangeAvgAmpHour = Math.round(getAvgFromArray(ampHoursArray));
        rangeHighAmpHour = rangeAvgAmpHour + sigmaOnAmpHours;
        if (Math.round(getAvgFromArray(ampHoursArray)) - sigmaOnAmpHours < 0) {
          rangeLowAmpHour = 0;
        } else {
          rangeLowAmpHour = rangeAvgAmpHour - sigmaOnAmpHours;
        }
      } else {
        rangeAvgAmpHour = "NA";
        rangeHighAmpHour = "NA";
        rangeLowAmpHour = "NA";
      }
      setRangeHighAmpHours(rangeHighAmpHour);
      setRangeLowAmpHours(rangeLowAmpHour);
      setGraphData(finalGraphData);
      setRefreshChart(true);
      setTimeout(() => setRefreshChart(false), 2000);
    }
  }, [getCarUsageState]);

  useEffect(() => {
    setRefreshChart(false);
  }, [getCarsData, getCurrentCarsData, getMessagesFromCarsData, getFaultsData]);

  const handleChartRefresh = (chartOptions, themeOptions, chartInstance) => {
    if (RefreshChart) {
      chartInstance.setOptions(chartOptions, themeOptions);
    }
  };

  return (
    <>
      <div className="header">
        <FleetUsageReportIcon />
        <p className="see-green-border">{t("Fleet_Usage_Reports")}</p>
      </div>
      <div className="box-body" style={{ padding: "60px 38px 38px" }}>
        <Chart onRefresh={handleChartRefresh}>
          <ChartTooltip />
          <ChartTitle text={t("Amp_Hours")} />
          <ChartLegend position="top" orientation="horizontal" />
          <ChartCategoryAxis>
            <ChartCategoryAxisItem startAngle={45} />
          </ChartCategoryAxis>
          <ChartSeries>
            {graphData.map((item, idx) => (
              <ChartSeriesItem
                key={idx}
                type="column"
                gap={1}
                color={(e) => {
                  if (
                    e.value > rangeHighAmpHours ||
                    e.value < rangeLowAmpHours ||
                    (rangeLowAmpHours === 0 && e.value === 0)
                  ) {
                    return "red";
                  } else {
                    return "green";
                  }
                }}
                data={item.ampHours}
                name={item.name}
              />
            ))}
          </ChartSeries>
        </Chart>
      </div>
    </>
  );
};

export default FleetUsageReports;
